// extracted by mini-css-extract-plugin
module.exports = {"modal":"BaseModal_modal__2ejef","fadein":"BaseModal_fadein__V_oz6","fadeIn":"BaseModal_fadeIn__1Q7H-"};